import { Model as t } from "../../../model.js";
class m extends t {
  constructor(s) {
    super(), this.ruleType = s.ruleType, this.maximumUses = s.maximumUses, this.timeframe = s.timeframe, this.timeframeSeconds = s.timeframeSeconds, this.unit = s.unit, this.weekDays = s.weekDays, this.locations = s.locations, this.startTime = s.startTime, this.endTime = s.endTime, this.fullDay = s.fullDay;
  }
}
export {
  m as UsageRuleModel
};
//# sourceMappingURL=usageRule.model.js.map
